import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products({ className, viewConfig }) {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    // class for four products: collection-products--four-column-grid
    // class for three products: collection-products--three-column-grid

    const getGridClasses = () => {
        const baseClasses = "product-grid collection-product-grid__products show-brand product-grid-container"
        const desktopClass = `collection-products--${viewConfig.desktop}-grid`
        const mobileClass = `collection-products--${viewConfig.mobile}-grid`
        
        return `${baseClasses} ${desktopClass} ${mobileClass} ${className || ''}`
    }

    useEffect(()=>{
        setTimeout(() => {
            document.addEventListener('click', function(e) {
                if (e.target.classList.contains('product-card__swatch')) {
                    e.preventDefault();
                }
            });
            document.querySelectorAll(".ns-serp .js-wishlist__add").forEach(el => {
                el.addEventListener("click", function(e){
                    e.preventDefault();
                })
            })
        }, 1000);
    })

    return (
        <div className={getGridClasses()} id="product-grid" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
